import { type ReactElement } from 'react';
import { type ButtonProps, Button as ReactAriaButton } from 'react-aria-components';

export function MenuButton(props: ButtonProps): ReactElement {
  return <ReactAriaButton {...props} />;
}
